module.exports = __webpack_public_path__ + "img/11_en.078456b5.png";